import type { ReactNode } from 'react'

// Extracted from MetersPage.tsx's MeterDrawer, the pattern the audit named
// as the standard for "look at/edit one thing while the surrounding context
// stays visible" (docs/plan-web-ux-cohesion.md, Phase 4) — the only one of
// the app's drill-down patterns that keeps triggering context visible
// behind/beside it. `title` is a node, not a string: both this shell's
// first adopters (MeterDrawer, DeviceDetailModal) have a multi-line header
// (category label + name + a mono id/serial), not a plain heading.
export function Drawer({ onClose, title, widthClass = 'max-w-md', children }: {
  onClose: () => void
  title: ReactNode
  widthClass?: string
  children: ReactNode
}) {
  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <div className="absolute inset-0 bg-black/20" onClick={onClose} />

      {/* No wrapper div around children imposing its own overflow -- MeterDrawer's
          own tabs/scrollable-content/footer are three siblings with different
          shrink/scroll behavior (shrink-0, flex-1 overflow-y-auto, shrink-0), not
          one blob. children lands as direct flex items here, same as today, so
          each part keeps whatever shrink/scroll class it already brings. */}
      <div className={`relative w-full ${widthClass} bg-white shadow-2xl flex flex-col h-full`}>
        <div className="flex items-start justify-between px-6 py-5 border-b border-gray-100 shrink-0">
          <div className="min-w-0">{title}</div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-1 -mr-1 shrink-0" aria-label="Zatvori">
            {/* Material Symbols "close" -- same path AppShell.tsx's ICONS.x uses,
                not the old stroke-based Heroicons glyph this was copied from. */}
            <svg className="w-5 h-5" viewBox="0 -960 960 960" fill="currentColor">
              <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
            </svg>
          </button>
        </div>

        {children}
      </div>
    </div>
  )
}
